import "regenerator-runtime/runtime";

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
 */
import { fork, all } from 'redux-saga/effects';
import watchSessionLogoff from './session/sagas/logoff';
import watchSessionTimeout from './session/sagas/session-timeout';
import watchDismissSessionTimeoutWarning from './session/sagas/dismiss-session-timeout';
import watchRequestLogoffConfirmation from './session/sagas/request-logoff-confirmation';
import watchBackNavigationRequestLogoffConfirmation from './session/sagas/back-navigation';
import { watchLanguage } from './language/language-saga.js';
import { watchFetchScenarios, watchSetScenario } from './scenarios/scenario-saga';
import { watchPushLogoffPrompt } from './navigation/sagas/push-logoff-prompt';
import { watchNavigationRequest, watchNavigationRequestWithId, watchNavigationRequestSamlBack, watchNavigation, watchNavigateBack } from './navigation/navigation-saga';
import watchNuanceNavigationRequest from './navigation/sagas/nuance-navigation';
import watchVoiceVerificationNavigationRequest from './navigation/sagas/voice-verification-navigation';
import { watchOpenNavigationMenu } from './navigation-menu/sagas/open-navigation';
import { watchCloseNavigationMenu } from './navigation-menu/sagas/close-navigation';
import { watchFetchNavigationConfig } from './navigation-menu/sagas/fetch-navigation-config';
import watchWorkflowStart from '../store/workflows/sagas/workflow-start';
import watchWorkflowEnd from '../store/workflows/sagas/workflow-end';
import watchWorkflowAbandon from '../store/workflows/sagas/workflow-abandon';
import watchWorkflowPreviousView from '../store/workflows/sagas/workflow-previous-view';
import watchWorkflowReturnToView from '../store/workflows/sagas/workflow-return-to-view';
import watchWorkflowUpdatePathForView from '../store/workflows/sagas/workflow-update-path-for-view';
import businessEventsSaga from './business-events/business-events-saga';
import cspViolationsSaga from './csp-violations/csp-violations-sagas';
import { watchGlobalSearchNavigate } from './global-search/sagas/global-search-navigate-saga';
import { watchOpenGlobalSearch, watchCloseGlobalSearch } from './global-search/sagas/global-search-toggle-saga';
import fetchGlobalSearchResults from './global-search/sagas/global-search-results-saga';
import fetchGlobalSearchSuggestions from './global-search/sagas/global-search-suggestions-saga';
import setTealiumPageId from './tealium/sagas/set-page-id-saga';
import setTealiumPageSubId from './tealium/sagas/set-page-sub-id-saga';
import wfFormSubmit from './wf-form/saga';
var rootSagas = /*#__PURE__*/regeneratorRuntime.mark(function rootSagas() {
  return regeneratorRuntime.wrap(function rootSagas$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return all([fork(watchSessionTimeout), fork(watchSessionLogoff), fork(watchDismissSessionTimeoutWarning), fork(watchRequestLogoffConfirmation), fork(watchLanguage), fork(watchFetchScenarios), fork(watchSetScenario), fork(watchOpenNavigationMenu), fork(watchCloseNavigationMenu), fork(watchFetchNavigationConfig), fork(watchNavigationRequest), fork(watchNavigationRequestWithId), fork(watchNuanceNavigationRequest), fork(watchVoiceVerificationNavigationRequest), fork(watchNavigationRequestSamlBack), fork(watchNavigation), fork(watchNavigateBack), fork(watchBackNavigationRequestLogoffConfirmation), fork(watchWorkflowStart), fork(watchWorkflowUpdatePathForView), fork(watchWorkflowReturnToView), fork(watchWorkflowPreviousView), fork(watchWorkflowEnd), fork(watchWorkflowAbandon), fork(businessEventsSaga), fork(cspViolationsSaga), fork(watchPushLogoffPrompt), fork(watchOpenGlobalSearch), fork(watchCloseGlobalSearch), fork(fetchGlobalSearchResults), fork(watchGlobalSearchNavigate), fork(fetchGlobalSearchSuggestions), fork(setTealiumPageId), fork(setTealiumPageSubId), fork(wfFormSubmit)]);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, rootSagas);
});
export default [rootSagas];